import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { REGEXPS } from '@/common';
import { API_URL } from '@/dtos';
export const GET_SSN_QUERY_KEY = 'GEt_EMPLOYEE_SSN';

const useGetEmployeeSSNQuery = (employeeId?: string) => {
  const { data, isSuccess, isError, isLoading } = useQuery(
    [GET_SSN_QUERY_KEY, employeeId],
    () => api.get(API_URL.UI_EMPLOYEES_SSN_BY_EMPLOYEE_ID(employeeId || ''), {}),
    {
      enabled: Boolean(employeeId),
      retry: false,
    }
  );

  const ssn = useMemo(() => {
    if (isError) {
      return '';
    }
    const currentSSN = data?.data?.ssn;
    if (currentSSN) {
      return currentSSN.replace(REGEXPS.SSN, '$1-$2-$3');
    }
    return '';
  }, [data?.data?.ssn, isError]);
  return {
    isSuccess,
    isLoading,
    ssn,
  };
};

export default useGetEmployeeSSNQuery;
